module.exports = __webpack_public_path__ + "img/IMG_5916.f5a6b933.jpg";